import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { MessengerProvider } from "@/context/MessengerContext";
import { LeadersProvider } from "@/context/LeadersContext";
import { Toaster } from "sonner";
import SiteHead from "@/components/SiteHead";
import MessengerHost from "@/components/messenger/MessengerHost";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Terms from "@/pages/Terms";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Dashboard from "@/pages/Dashboard";
import BuyCredits from "@/pages/BuyCredits";
import BuyUpgrades from "@/pages/BuyUpgrades";
import BuyBanners from "@/pages/BuyBanners";
import MyBanners from "@/pages/MyBanners";
import BuyTextAds from "@/pages/BuyTextAds";
import MyTextAds from "@/pages/MyTextAds";
import Surf from "@/pages/Surf";
import Websites from "@/pages/Websites";
import Notifications from "@/pages/Notifications";
import Feed from "@/pages/Feed";
import Discover from "@/pages/Discover";
import UserProfile from "@/pages/UserProfile";
import Messages from "@/pages/Messages";
import StartPages from "@/pages/StartPages";
import Referrals from "@/pages/Referrals";
import Statistics from "@/pages/Statistics";
import Support from "@/pages/Support";
import Profile from "@/pages/Profile";
import SplashPages from "@/pages/SplashPages";
import SplashEditor from "@/pages/SplashEditor";
import PublicSplash from "@/pages/PublicSplash";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminWebsites from "@/pages/admin/AdminWebsites";
import AdminSplash from "@/pages/admin/AdminSplash";
import AdminLoginDeals from "@/pages/admin/AdminLoginDeals";
import AdminSurfDeals from "@/pages/admin/AdminSurfDeals";
import LoginDeal from "@/pages/LoginDeal";
import SurfDeal from "@/pages/SurfDeal";
import AdminStartPages from "@/pages/admin/AdminStartPages";
import AdminReports from "@/pages/admin/AdminReports";
import AdminStore from "@/pages/admin/AdminStore";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminTickets from "@/pages/admin/AdminTickets";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminVisitors from "@/pages/admin/AdminVisitors";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminVerification from "@/pages/admin/AdminVerification";
import AdminPrizePages from "@/pages/admin/AdminPrizePages";
import AdminDraws from "@/pages/admin/AdminDraws";
import SurfPrize from "@/pages/SurfPrize";
import SurfDrawnWinners from "@/pages/SurfDrawnWinners";
import MyRotors from "@/pages/MyRotors";
import PublicRotor from "@/pages/PublicRotor";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <MessengerProvider>
        <LeadersProvider>
        <BrowserRouter>
          <SiteHead />
          <Toaster position="top-right" richColors closeButton />
          <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/s/:slug" element={<PublicSplash />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Terms />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/buy-credits" element={<ProtectedRoute><BuyCredits /></ProtectedRoute>} />
          <Route path="/buy-upgrades" element={<ProtectedRoute><BuyUpgrades /></ProtectedRoute>} />
          <Route path="/buy-banners" element={<ProtectedRoute><BuyBanners /></ProtectedRoute>} />
          <Route path="/my-banners" element={<ProtectedRoute><MyBanners /></ProtectedRoute>} />
          <Route path="/buy-text-ads" element={<ProtectedRoute><BuyTextAds /></ProtectedRoute>} />
          <Route path="/my-text-ads" element={<ProtectedRoute><MyTextAds /></ProtectedRoute>} />
          <Route path="/surf" element={<ProtectedRoute><Surf /></ProtectedRoute>} />
          <Route path="/surf/prize" element={<ProtectedRoute><SurfPrize /></ProtectedRoute>} />
          <Route path="/surf-drawn-winners" element={<ProtectedRoute><SurfDrawnWinners /></ProtectedRoute>} />
          <Route path="/my-rotors" element={<ProtectedRoute><MyRotors /></ProtectedRoute>} />
          <Route path="/r/:slug" element={<PublicRotor />} />
          <Route path="/websites" element={<ProtectedRoute><Websites /></ProtectedRoute>} />
          <Route path="/websites/new" element={<ProtectedRoute><Websites /></ProtectedRoute>} />
          <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
          <Route path="/statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/messages/:uid" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/start-pages" element={<ProtectedRoute><StartPages /></ProtectedRoute>} />
          <Route path="/splash" element={<ProtectedRoute><SplashPages /></ProtectedRoute>} />
          <Route path="/splash/new" element={<ProtectedRoute><SplashEditor /></ProtectedRoute>} />
          <Route path="/splash/:id/edit" element={<ProtectedRoute><SplashEditor /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
          <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
          <Route path="/discover" element={<ProtectedRoute><Discover /></ProtectedRoute>} />
          <Route path="/u/:uid" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/websites" element={<ProtectedRoute adminOnly><AdminWebsites /></ProtectedRoute>} />
          <Route path="/admin/splash" element={<ProtectedRoute adminOnly><AdminSplash /></ProtectedRoute>} />
          <Route path="/admin/login-deals" element={<ProtectedRoute adminOnly><AdminLoginDeals /></ProtectedRoute>} />
          <Route path="/admin/surf-deals" element={<ProtectedRoute adminOnly><AdminSurfDeals /></ProtectedRoute>} />
          <Route path="/login-deal" element={<ProtectedRoute><LoginDeal /></ProtectedRoute>} />
          <Route path="/surf-deal" element={<ProtectedRoute><SurfDeal /></ProtectedRoute>} />
          <Route path="/admin/start-pages" element={<ProtectedRoute adminOnly><AdminStartPages /></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute adminOnly><AdminReports /></ProtectedRoute>} />
          <Route path="/admin/store" element={<ProtectedRoute adminOnly><AdminStore /></ProtectedRoute>} />
          <Route path="/admin/payments" element={<ProtectedRoute adminOnly><AdminPayments /></ProtectedRoute>} />
          <Route path="/admin/plans" element={<ProtectedRoute adminOnly><AdminPlans /></ProtectedRoute>} />
          <Route path="/admin/tickets" element={<ProtectedRoute adminOnly><AdminTickets /></ProtectedRoute>} />
          <Route path="/admin/announcements" element={<ProtectedRoute adminOnly><AdminAnnouncements /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
          <Route path="/admin/visitors" element={<ProtectedRoute adminOnly><AdminVisitors /></ProtectedRoute>} />
          <Route path="/admin/referrals" element={<ProtectedRoute adminOnly><AdminReferrals /></ProtectedRoute>} />
          <Route path="/admin/activity" element={<ProtectedRoute adminOnly><AdminActivity /></ProtectedRoute>} />
          <Route path="/admin/verification" element={<ProtectedRoute adminOnly><AdminVerification /></ProtectedRoute>} />
          <Route path="/admin/prize-pages" element={<ProtectedRoute adminOnly><AdminPrizePages /></ProtectedRoute>} />
          <Route path="/admin/draws" element={<ProtectedRoute adminOnly><AdminDraws /></ProtectedRoute>} />
          </Routes>
          <MessengerHost />
        </BrowserRouter>
        </LeadersProvider>
      </MessengerProvider>
    </AuthProvider>
  );
}

export default App;
